import { GeoJsonLayer } from '@deck.gl/layers';
import { LayerType, type LayerConfig } from './types';
import { type RedFlagWarning } from '@/features/wildfireSlice';
import { feature, featureCollection } from '@turf/helpers';
import { type RedFlagWarningInfoProps } from '@/views/map/RedFlagWarning/RedFlagWarningInfo';

export const getRedFlagWarningLayer = (
  redFlagWarnings: RedFlagWarning[],
  config: LayerConfig
) => {
  const data = featureCollection(
    redFlagWarnings?.map((w: RedFlagWarning) => {
      const properties: RedFlagWarningInfoProps | { id: string } = {
        id: w.id,
        title: w.area,
        coveredCircuits: w.coveredCircuits,
        coveredDistance: w.coveredDistance,
        issued: w.issued_date,
        start: w.start_date,
        end: w.expiration_date,
        nwsLink:
          'https://forecast.weather.gov/wwamap/wwatxtget.php?cwa=usa&wwa=red+flag+warning',
      };
      return feature(w.geometry.geometry, properties);
    })
  );

  return new GeoJsonLayer({
    data,
    id: LayerType[LayerType.red_flag_warning],
    getLineColor: () => [255, 76, 151],
    getFillColor: () => [255, 76, 151, 51],
    pickable: true,
    filled: true,
    autoHighlight: false,
    lineWidthMinPixels: 3,
    ...config,
  });
};
